import { render, staticRenderFns } from "./diceStorm.vue?vue&type=template&id=4f6811d7&scoped=true"
import script from "./diceStorm.vue?vue&type=script&lang=js"
export * from "./diceStorm.vue?vue&type=script&lang=js"
import style0 from "./diceStorm.vue?vue&type=style&index=0&id=4f6811d7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f6811d7",
  null
  
)

export default component.exports